<div class="start-page flex flex-col flex-start-center">
  <img class="start-image hidden sm:block" src="assets/images/evaluation/start.png" />
  <div class="title">
    Evaluation of:
    <br />
    {{ evaluationData.ConsultantName }}
  </div>
  <div class="description">
    We really appreciate your time that's why this evaluation consists of
    <strong>7 questions</strong>
    only and will take you maximum
    <strong>5 minutes</strong>
  </div>
  <div class="actions">
    <button (click)="startEvaluation()" color="accent" mat-flat-button>Start evaluation</button>
  </div>
</div>
